export const SUCCESS_UPDATE_MESSAGE =
  'Your changes have been successfully saved'
export const ALL = 'All'
export const SELECT_ALL = 'Select all'
export const SEARCH_FOR = 'Search for'
export const SELECT = 'Select'
export const ENTER = 'Enter'
export const ASCENDING = 'Asc'
export const DESCENDING = 'Desc'
export const ADD = 'Add'
export const NEXT = 'Next'
export const RESET_ALL = 'Reset all'
export const SUBMIT = 'Submit'
export const COMPLETE = 'Complete'
export const PLEASE_UPLOAD_FILE = 'Please upload file'

export const PAGE_NAMES = {
  ACTIVITY_HISTORY_DETAILS: 'Activity history details',
  STOP_SALE: 'Stop sale',
  PRICE_LIST: 'Price list',
  RATES: 'Rates',
}

export const COMPLETE_CONFIRMATION: Record<string, { [key: string]: string }> =
  {
    CONFIRMATION_MODAL: {
      QUESTION:
        'By clicking “Submit” you agree that you will not be able to edit your details until we have verified the information you provided.',
      TITLE: 'Ready to submit?',
      BUTTON_LABEL: 'Submit',
    },
    LOCATIONS: {
      QUESTION:
        'Do you want to go back to adding/editing the location or complete the process? In the second case, the details of your last location will not be saved.',
      TITLE: 'You have not finished adding/editing your last location.',
      CANCEL_LABEL: 'Go back',
      BUTTON_LABEL: 'Complete',
    },
    VEHICLES: {
      QUESTION:
        'Do you want to go back to adding/editing the car or complete the process? In the second case, the details of your last car will not be saved.',
      TITLE: 'You have not finished adding/editing your last car.',
      CANCEL_LABEL: 'Go back',
      BUTTON_LABEL: 'Complete',
    },
    TERMS: {
      QUESTION:
        'By clicking “Submit” you agree that you will not be able to edit your details until we have verified the information you provided.',
      TITLE: 'Ready to submit?',
      BUTTON_LABEL: 'Submit',
    },
  }
